import { useCallback } from "react";

import { useSiteControllerSettingNotUsingMutation } from "../repository";

export const useUpdateSiteControllerSettingNotUsing = () => {
	const { onUpdate: _onUpdate } = useSiteControllerSettingNotUsingMutation();

	const onUpdate = useCallback(
		async ({ hotelID }: { hotelID: string }) => {
			const input = {
				hotelID,
			};
			return await _onUpdate({ input });
		},
		[_onUpdate],
	);

	return {
		onUpdate,
	};
};
